import {Menu} from "antd";
import {NavLink} from "react-router-dom";
import {RoutingPaths} from "../../pages/routing/routingContainer";
import styles from "./siderMenu.module.less";
import {useCurrentRoutingPath} from "digimuth-components/dist";
import logo from "../../assets/logo-warto.svg";
import React from "react";
import {
    getNavigationItemsBySection,
    getRouteContextByPattern,
    NavigationItemDefinition
} from "../../navigation/navigationConfig";
import useCurrentUserRoles from "../../hooks/useCurrentUserRoles";

export type MenuItem = NavigationItemDefinition;

export default function SiderMenu() {
    const route = useCurrentRoutingPath(RoutingPaths)?.route || "";
    const selectedRoute = getRouteContextByPattern(route)?.navRoute || route;
    const menuItems = useMenuItems();

    return <>
        <NavLink to={"/"}>
            <img alt={"logo"} src={logo} className={styles.logo}/>
        </NavLink>
        <Menu
            theme="dark"
            selectedKeys={[selectedRoute]}
            mode="inline"
            items={menuItems.map(section => ({
                key: section.key,
                type: "group",
                label: (
                    <div className={styles.groupLabel}>
                        <span className={styles.groupTitle}>{section.label}</span>
                    </div>
                ),
                children: section.items.map((item: MenuItem) => ({
                    key: item.route,
                    icon: item.icon,
                    label: <NavLink to={item.route}>
                        {item.displayName}
                    </NavLink>
                }))
            }))}
        />
    </>;
}

export function useMenuItems() {
    const roles = useCurrentUserRoles();
    return getNavigationItemsBySection(roles ?? undefined);
}
